import { all, call, put } from 'redux-saga/effects';
import { get, post } from '../services/api';
import {
  getMimefile,
  objectToPascalCase,
} from '../services/utils';
import {
  addAttachmentsLoad,
  claimRequested,
  failedToLoadClaimSteps,
  getClaimAttachmentsFailed,
  getClaimAttachmentsLoaded,
  getClaimByIdFailed,
  getClaimByIdLoaded,
  newClaimStepsLoaded,
  fileClaimsAttachmentUpdated,
  claimsResultsLoadedError,
  claimsResultsLoadedSuccess,
  claimsResultsLoadedMore,
} from '../actions';
import {
  useClaimsAPIV2T159603ForSagas,
  usePetCloudClaimsApiV1T164407ForSagas,
  usePetCloudClaimsV1T1T174557ForSagas,
} from '../services/featureFlagsForSagas';

export function* loadNewClaimSteps(dispatch) {
  const response = yield call(get, dispatch, 'api/Bot/GetClaimTypeSteps/0/1');

  if (response.success && response.IsValid) {
    yield put(newClaimStepsLoaded(response.Data));
  } else {
    yield put(failedToLoadClaimSteps());
  }
}

export function* getAttachmentsByClaim(dispatch, action) {
  yield put(claimRequested());
  const response = yield call(
    get,
    dispatch,
    'api/PMS/Claim/GetClaimAttachments',
    { claimId: action.payload.cliamId },
  );

  if (response.success && response.IsValid) {
    yield put(getClaimAttachmentsLoaded(response.Data));
  } else {
    yield put(getClaimAttachmentsFailed());
  }
}

export function* getClaimByNumber(dispatch, action) {
  const { claimNumber } = action.payload;
  yield put(claimRequested());
  const response = yield call(
    get,
    dispatch,
    'api/PMS/Claim/Get',
    { claimNumber },
  );

  if (response.success && response.IsValid && response.Data) {
    yield put(getClaimByIdLoaded(response.Data));
  } else {
    yield put(getClaimByIdFailed());
  }
}

function* saveAttachment(dispatch, file, ClaimId, t) {
  try {
    const PetCloudClaimsApiV1T164407 =
      yield usePetCloudClaimsApiV1T164407ForSagas();

    const url = PetCloudClaimsApiV1T164407
      ? 'claims/claims/AddClaimAttachment'
      : 'api/PMS/Claim/AddClaimAttachment';

    const postBody = {
      ClaimId,
      ContentType: getMimefile(file.extension?.toLowerCase()),
      Extension: file.extension,
      FileContent: file.binary,
      FileName: file.filename,
    };

    const response = yield call(post, dispatch, url, postBody);

    if (response.success && response.IsValid) {
      dispatch(fileClaimsAttachmentUpdated({
        key: file.key,
        percentage: 100,
        uploadValid: true,
        valid: true,
      }));
    } else {
      dispatch(fileClaimsAttachmentUpdated({
        errorMsg: t('conectionError'),
        key: file.key,
        percentage: 100,
        uploadValid: false,
        valid: false,
      }));
    }
  } catch (_) {
    dispatch(fileClaimsAttachmentUpdated({
      errorMsg: t('conectionError'),
      key: file.key,
      percentage: 100,
      uploadValid: false,
      valid: false,
    }));
  }
}

export function* addAttachmentToClaim(dispatch, action) {
  const { files, ClaimId, t } = action.payload;
  yield all(files.map((file) => {
    let progress = 0;
    while (progress <= 74) {
      progress += 1;
      dispatch(fileClaimsAttachmentUpdated({
        key: file.key,
        percentage: progress,
      }));
    }

    return saveAttachment(dispatch, file, ClaimId, t);
  }));

  dispatch(addAttachmentsLoad({ loading: false, success: true }));
}

function* getClaimsDataLegacy(payload) {
  const url = 'api/MultiBrand/Claims';
  return yield call(post, null, url, payload);
}

function* getClaimsDatav2(payload) {
  const url = 'claims/MultiBrand/claims';
  const payloadFormatted = {
    'market-channel-ids': payload.marketChannelIds || [],
    'page-number': payload.pageNumber || 0,
    'pet-ids': payload.petIds || [],
    status: payload.status,
  };

  const claimsData = yield call(get, null, url, payloadFormatted);
  const payloadFormated = objectToPascalCase(claimsData);

  return {
    Data: payloadFormated,
    IsValid: !!(payloadFormated && payloadFormated.Items
      && payloadFormated.Items.length),
    Message: payloadFormated.Message || '',
  };
}

function* getClaimsData(payload) {
  const useClaimsAPIV2T159603 = yield useClaimsAPIV2T159603ForSagas();
  const toBeExecuted = useClaimsAPIV2T159603
    ? getClaimsDatav2 : getClaimsDataLegacy;

  return yield toBeExecuted(payload);
}

export function* fetchClaimsResults({ payload }) {
  try {
    const action = payload.pageNumber > 0
      ? claimsResultsLoadedMore
      : claimsResultsLoadedSuccess;

    const claimsData = yield getClaimsData(payload);

    if (claimsData && claimsData.IsValid) {
      yield put(action({
        data: claimsData.Data,
        status: payload.status,
      }));
    } else {
      yield put(claimsResultsLoadedError(claimsData.Message));
    }
  } catch (error) {
    yield put(claimsResultsLoadedError(error.message));
  }
}

export function* fetchClaimById(dispatch, { payload }) {
  try {
    const { claimId } = payload;

    const PetCloudClaimsV1T1T174557 =
      yield usePetCloudClaimsV1T1T174557ForSagas();
    const service = PetCloudClaimsV1T1T174557 ? 'claims' : 'api';
    const url = `${service}/MultiBrand/Claim/${claimId}`;

    const response = yield call(get, dispatch, url);

    if (response?.success && response?.IsValid && response?.Data) {
      yield put(getClaimByIdLoaded(response.Data));
    } else {
      yield put(getClaimByIdFailed());
    }
  } catch (error) {
    yield put(getClaimByIdFailed());
  }
}
